export enum TaskState {
  Completed = 'completed',
  Pending = 'pending',
}
